module.exports = __webpack_public_path__ + "0da2849a10e2a30d6cf565bff3042431.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C0000697O.png
// module id = 1572
// module chunks = 0